// Users who have bid history are scrubbed rather than deleted (see users.js and
// admin.js), which leaves the literal sentinel '[deleted]' in fname. That sentinel
// is load-bearing in backend queries, so it stays in the database — it just should
// never be what a person reads.
export const DEACTIVATED_SENTINEL = '[deleted]';

export function isDeactivated(user = {}) {
  return user.fname === DEACTIVATED_SENTINEL;
}

/**
 * Human-readable name for a bid/transaction counterparty.
 * @param parts  { fname, lname, id } — id is used for the fallback label
 * @param label  what to call the record type in the fallback ('Buyer', 'Seller')
 */
export function displayName({ fname, lname, id } = {}, label = 'Buyer') {
  if (fname === DEACTIVATED_SENTINEL) return 'Former user';
  const full = [fname, lname].filter(Boolean).join(' ');
  return full || (id != null ? `${label} #${id}` : '—');
}
